import { apiClient } from "../apiClient";

const DASHBOARD_ENDPOINT = "dashboard";
export const dashboardApi = {
    SelectDashboard: () => apiClient.get(`${DASHBOARD_ENDPOINT}`),
}
